import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d434823"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner" }

import { withDefaults, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Container',
  props: {
    color: { default: "#000" },
    width: { default: "1440px" },
    className: { default: "" }
  },
  setup(__props: any) {

const $props = __props as { color: string, width: string, className: string };



const containerRef = ref(null);

onMounted(() => {
  if (containerRef.value) {
    // 设置背景颜色CSS变量
    containerRef.value.style.setProperty('--container-bg', $props.color);
    // 设置内部宽度CSS变量
    const innerElement = containerRef.value.querySelector('.inner');
    if (innerElement) {
      innerElement.style.setProperty('--inner-width', $props.width);
    }
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "containerRef",
    ref: containerRef,
    class: 'layout-container ' + __props.className
  }, _ctx.$attrs), [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 16))
}
}

})